import qs from "qs"

import { apiURL } from "@/config/service.js"

import { request } from "@/utils/httpAxios.js"

class Http {
  // constructor() {

  // }

  async post(
    url,
    data = {},
    headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  ) {
    const configs = {
      method: "post",

      url: apiURL + url,

      data,

      headers
    }

    if (Object.keys(data).length) {
      if (headers["Content-Type"].indexOf("application/json") === -1) {
        Object.assign(configs, {
          transformRequest: [
            function(data) {
              // Do whatever you want to transform the data

              return qs.stringify(data)
            }
          ]
        })
      }
    }

    return new Promise(function(resolve, reject) {
      // const request = axios.create();

      request(configs)
        .then(response => {
          // response.data.status ? resolve(response) : reject(new Error(response.data.msg))

          // ticket 无效

          // if (response.code === 600) {

          // window.location.href = `${loginURL.baseURL}?ReturnUrl=${loginURL.returnURL}`

          // }

          resolve(response.data);
        })
        .catch(error => {
          reject(new Error(error));
        });
    });
  }

  async get(
    url,
    data = {},
    headers = {
      "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
    }
  ) {
    // 数据拼接

    const query = qs.stringify(data);

    const configs = {
      method: "get",

      url: apiURL + url + "?" + query,

      data,

      headers
    }

    return new Promise(function(resolve, reject) {
      // const request = axios.create();

      request(configs)
        .then(response => {
          // response.data.status ? resolve(response) : reject(new Error(response.data.msg))

          resolve(response)
        })
        .catch(error => {
          reject(new Error(error))
        })
    })
  }
}

const HttpObject = new Http()

// const httpPost = HttpObject.post()

export  { HttpObject as Http }



// WEBPACK FOOTER //
// ./src/utils/http.js